import { useEffect, useRef } from "react";
import { Loader2 } from "lucide-react";

// Sentinel that calls onReach() when scrolled into view. Drop it at the bottom
// of any list/grid backed by useInfiniteScroll.
export default function InfiniteSentinel({
  onReach,
  hasMore,
  loading,
  testId = "infinite-sentinel",
  endLabel = "That's everything",
  loadingLabel = "Loading more…",
  count,
  total,
}) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !hasMore) return undefined;
    const io = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting && hasMore && !loading) onReach(); },
      { rootMargin: "400px" },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [onReach, hasMore, loading]);

  return (
    <div
      ref={ref}
      data-testid={testId}
      data-has-more={hasMore ? "true" : "false"}
      className="py-5 flex items-center justify-center text-[11px] font-mono text-slate-500 uppercase tracking-widest"
    >
      {loading ? (
        <span className="inline-flex items-center gap-2 text-slate-400">
          <Loader2 className="w-4 h-4 animate-spin" /> {loadingLabel}
        </span>
      ) : hasMore ? (
        <span className="text-slate-600">Scroll for more</span>
      ) : (count > 0 ? (
        <span className="text-slate-600">
          {endLabel}{typeof total === "number" && total > 0 ? ` · ${count} of ${total}` : ""}
        </span>
      ) : null)}
    </div>
  );
}
